import './styles/reviewSubsSummaryCard.scss';
import React, { useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Card } from 'cdk-radial';
import { withRouter } from 'react-router-dom';
import {
  setPlanAmountText,
  setPlanFrequencyText,
  setUserComment,
  setEmailsForSubscriptionNotifications
} from '../../../../redux/connectedComponent/reviewSubscription/reviewSubscription.slice';

function ReviewSubsSummaryCard(props) {
  const LOCATION = "Location(s)";
  const dispatch = useDispatch();
  const subscriptionManagementState = useSelector(state => state);
  const {
    selectedLocations,
    locationsToAddForSubManagement = []
  } = subscriptionManagementState.selectLocationsSlice;
  const {
    overview
  } = subscriptionManagementState.solutionInfoSlice.solutionInfo;
  const planDetails = subscriptionManagementState.solutionInfoSlice.planDetails;
  const selectedPlanId=subscriptionManagementState.solutionInfoSlice.selectedPlanId;
  let planId ='';
  (selectedPlanId && selectedPlanId !== '') ? planId=selectedPlanId 
    : planId=props.match && props.match.params && props.match.params.selectedPlanId;

  // const planId =
  // props.match && props.match.params && props.match.params.selectedPlanId;
  const {
    planAmountText,
    planFrequencyText
  } = subscriptionManagementState.reviewSubscriptionSlice;

  useEffect(() => {
    if (Array.isArray(planDetails) && planDetails.length > 0) {
      let filteredPlan = planDetails.filter(plan => {
        return plan.id === planId;
      });
      let basePrice = filteredPlan && filteredPlan.length && filteredPlan[0] && filteredPlan[0].basePrice || 0;
      let includedTransactionalFee = filteredPlan && filteredPlan.length && filteredPlan[0] && filteredPlan[0].includedTransactionalFee || 0;
      let includedTransactionalType = filteredPlan && filteredPlan.length && filteredPlan[0] && filteredPlan[0].includedTransactionalType || 'install';
      if (Array.isArray(filteredPlan) && filteredPlan.length > 0) {
        if (
          filteredPlan[0].isFreeTrialEnabled ||
          filteredPlan[0].isTheFreeTrial ||
          filteredPlan[0].billingType === 'FREE'
        ) {
          dispatch(
            setPlanAmountText({ planAmount: `$${basePrice}` })
          );
          dispatch(
            setPlanFrequencyText({
              planFrequency: `${filteredPlan[0].planName}`
            })
          );
        } else if (filteredPlan[0].billingType === 'RECURRING') {
          dispatch(
            setPlanAmountText({ planAmount: `$${basePrice}` })
          );
          dispatch(
            setPlanFrequencyText({
              planFrequency: `Per ${filteredPlan[0].billingFrequency}`
            })
          );
        } else if (filteredPlan[0].billingType === 'ONE TIME') {
          dispatch(
            setPlanAmountText({ planAmount: `$${basePrice}` })
          );
          dispatch(
            setPlanFrequencyText({
              planFrequency: `${filteredPlan[0].billingType}`
            })
          );
        } else if (filteredPlan[0].billingType === 'TRANSACTIONAL') {
          if (filteredPlan[0].transactionalTypeOptions === '$') {
            dispatch(
              setPlanAmountText({
                planAmount: `${filteredPlan[0].transactionalTypeOptions} ${includedTransactionalFee}`
              })
            );
          } else {
            dispatch(
              setPlanAmountText({
                planAmount: `${includedTransactionalFee} ${filteredPlan[0].transactionalTypeOptions}`
              })
            );
          }
          dispatch(
            setPlanFrequencyText({
              planFrequency: `Per ${includedTransactionalType}`
            })
          );
        }
      }
    }
}, []);

  useEffect(()=>{
  dispatch(
    setUserComment({
      userComment: props.installNote
    })
  );
},[props.installNote])

  useEffect(()=>{
    dispatch(
      setEmailsForSubscriptionNotifications({
        emailsForSubscriptionNotifications: props.emailsForSubscriptionNotifications
      })
    );
  },[props.emailsForSubscriptionNotifications])


  return (
    <div className="solution-review-content">
      <div className="solution-review-card">
        <Card>
          <img
            src={overview ? overview.solutionLogo : ''}
            alt="App Logo"
            className="solution-review-card-logo"
          ></img>
        </Card>
      </div>
      <div className="solution-review-details">
        <div className="solution-review-details-head">
          {overview.name ? overview.name : ''}
        </div>
        <div className="solution-review-details-subHead">
          {overview.publisherName ? overview.publisherName : ''}
        </div>
      </div>
      <div className="solution-review-locations">
        <div className="solution-review-details-head">
          {selectedLocations.length !== 0 ? selectedLocations.length : locationsToAddForSubManagement.length}
        </div>
        <div className="solution-review-details-subHead">{LOCATION}</div>
      </div>
      <div className="solution-review-price">
        <div className="solution-review-details-head">{planAmountText}</div>
        <div className="solution-review-details-subHead">
          {planFrequencyText}
        </div>
      </div>
    </div>
  );
}
export default withRouter(ReviewSubsSummaryCard);